import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const ArrowBackground: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon viewBox="0 0 407 672" {...props}>
    <path
      d="M235.505 456C275.266 416.215 544.415 146.899 544.415 146.899C562.766 128.537 575 107.114 575 85.6913C575 64.2684 565.824 45.906 547.473 27.5436C529.122 9.1812 510.771 0 489.362 0C467.952 0 446.542 9.18121 428.191 30.604L0 456L425.133 881.396C443.484 899.758 464.894 912 486.303 912C507.713 912 526.064 902.819 544.415 884.456C562.766 866.094 571.941 847.732 571.941 826.309C571.941 804.886 562.766 783.463 541.356 765.101L235.505 456Z"
      fill="#CCCC00"
    />
  </SvgIcon>
);

export default ArrowBackground;
